// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XwSv","tabsBox":"styles_tabsBox__3ejSO","createButton":"styles_createButton__1TyRx"};